import React from 'react';
import { VerifiedIcon } from '@atlaskit/legacy-custom-icons';
export var VerifiedTeamIcon = function VerifiedTeamIcon(_ref) {
  var size = _ref.size,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Verified Team' : _ref$label;
  return /*#__PURE__*/React.createElement(VerifiedIcon, {
    primaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
    size: size,
    label: label
  });
};